import { RuleType, UserType } from '@enrollhere/classes';
import { CreditAccountType } from '@enrollhere/classes';
import { CreditAccount } from '@enrollhere/classes';

export const CARRY_FORWARD_ACCOUNT_ID = 'default';

export const getDefaultCarryForwardAccount = (
  agencyId?: string
): CreditAccount => ({
  id: CARRY_FORWARD_ACCOUNT_ID,
  name: 'Default',
  type: CreditAccountType.CA_CREDIT,
  owner: {
    id: agencyId,
    type: UserType.AGENCY,
  },
  rule: {
    type: RuleType.RLT_TO_ZERO,
    takeNegativeBalance: true,
  },
});
